import React, { useMemo } from 'react';
import { useRefinementList, useInstantSearch } from 'react-instantsearch';
import { usePrevious } from 'react-use';

import BrowserOnly from 'components/consumer/BrowserOnly';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
import { FABRIC_COLOR_CODES_MAP } from 'commons/constants';
import ProductListingColorFilter from './components/ProductListingColorFilter';

const DesktopProductListingColorFilter = () => {
  const { items: colorFilters, refine: refineColorFilters } = useRefinementList(
    {
      attribute: 'option_color',
    }
  );
  const { results } = useInstantSearch();

  const colors = useMemo(
    () =>
      Object.keys(FABRIC_COLOR_CODES_MAP).filter(c =>
        colorFilters.some(cf => cf.label?.toLowerCase() === c)
      ),
    [colorFilters]
  );

  const previousColors = usePrevious(colors);

  const displayColors = useMemo(() => {
    if (colors.length) {
      return colors;
    }

    // If there are no colors and also no results, show an empty color filter
    // instead of showing the previous colors. This is to prevent showing
    // irrelevant colors when the search query changes and there are no results
    // for the new query.
    if (results?.nbHits === 0) {
      return [];
    }

    // If there are no colors then we want to keep showing the previous colors
    // until new ones are available. This is to prevent the color filter from
    // disappearing while the search results are loading.
    return previousColors ?? [];
  }, [colors, results?.nbHits, previousColors]);

  return (
    <BrowserOnly>
      <TabletAndDesktopOnly>
        <div className="hidden md:block">
          <ProductListingColorFilter
            colors={displayColors}
            colorFilters={colorFilters}
            refineColorFilters={refineColorFilters}
          />
        </div>
      </TabletAndDesktopOnly>
    </BrowserOnly>
  );
};

export default DesktopProductListingColorFilter;
